import { TYPES as ADS_TYPES } from '../actions/adActions'
import { queryString } from '../../utils/window'
import { BaseStore } from './baseStore'
import { AD_FORMATS } from '../config/adsConfig'
import { TYPES } from '../actions/navbarActions'
import { getSingleElementByClass } from '../../utils/dom'
import pageDataObject from '../../application/pageDataObject'
import scrollingEventsProvider from '../../providers/scrollingEventsProvider'

const { adsDebugSizes } = queryString

class NavbarStore extends BaseStore {
  constructor(options = {}) {
    super(options)
    this.merge({
      isStickyEnabled: false,
      hasTitle: false,
    })
  }

  routeAction(action) {
    let ACTIONS = TYPES
    switch (action.type) {
      case ACTIONS.REACHED_POST_TITLE:
        return this.repositionTitle(action.scrollingEventObject)
      case ADS_TYPES.SLOT_RENDERED:
        const { adId, event: e } = action
        adsDebugSizes && this.info(adId, e)
        if (adId === AD_FORMATS.Top && e.size) {
          this.repositionMobileHeader(e.size[1])
        }
        return this
      default:
        return this
    }
  }

  get isStickyEnabled() {
    return this.state.isStickyEnabled
  }
  set isStickyEnabled(bool) {
    this.state.isStickyEnabled = bool
  }
  get hasTitle() {
    return this.state.hasTitle
  }
  set hasTitle(bool) {
    this.state.hasTitle = bool
  }

  repositionMobileHeader(topHeight) {
    return this.emitChange({ topHeight })
  }

  repositionTitle(isInViewport) {
    const eventConfig = {
      isInViewport,
      triggerFlag: 'hasTitle',
      triggerEvent: 'emitChange',
      customCondition:
        window.scrollY > getSingleElementByClass('post-article__post-title').offsetTop,
      store: this,
    }
    scrollingEventsProvider.triggerEventOnce(eventConfig)
    return this
  }
}

const navbarStore = NavbarStore.create()

export default navbarStore



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/navbarStore.js